import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';
import ModalSimple from '../../global/modal-simple';
import * as emitter from '../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../global/store/ab-test.store';
import InfoIcon from './shared/info-icon';
import {screenResizeStore} from '../../global/store/screen-resize-store';

declare var __fast_ship: boolean;
declare const window: any;

@observer
export default class Glass extends React.Component {
    @observable collapsed: boolean = true;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    abForceUpdate = async () => this.forceUpdate();

    componentDidMount() {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
    }

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
    };

    @action
    save = async (id: number) => {
        s.ui.update_pricing = true;
        s.pcs.glass_id = id;
        s.pulse();
    };

    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || this.isMobile;
    }

    @computed get isMobile(): boolean {
        return screenResizeStore.width < 960;
    }

    render() {
        if (!s.ready || !s.ui.show_cust || !s.prod || !s.si || !s.si.IsGlassAllowed) {
            return;
        }
        if (!s.prod.IsFrame) {
            return;
        }
        if (s.prod.ProductID === 70214) {
            return;
        }
        if (s.prod.ProductID === 84054) {
            return;
        }

        const standardGlassTitle = (id: number = s.pcs.glass_id) => id === 1 && AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && 'Basic';

        return (
            <div
                className="gray-box"
                style={{padding: 0}}
            >
                <div>
                    <ModalSimple
                        id="modal-glass"
                        title="Glass Information"
                    >
                        <div>
                            <div className="header-std">
                                {s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi ? 'Plexi' : 'Clear'} (Standard {s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi ? 'Plexiglass' : 'Glass'})
                            </div>
                            <p style={{marginBottom: 0}}>Clear standard {s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi ? 'plexiglass' : 'glass'} blocks 45% of UV light. Use when UV exposure is not a concern.</p>
                            {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod.AllowGlassID2 > 0 && (
                                <div>
                                    <div className="header-std">Reflection Control</div>
                                    <p>Matte finish to reduce glare and blocks 45% of UV light. Diminishes unwanted glare.</p>
                                </div>
                            )}
                            {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod.AllowGlassID3 > 0 && (
                                <div>
                                    <div className="header-std">Conservation UV Protection</div>
                                    <p>Blocks up to 99% of UV light. Offers maximum protection against fading.</p>
                                </div>
                            )}
                            {s.prod.AllowGlassID4 > 0 && (
                                <div>
                                    <div className="header-std">Conservation UV + Reflection Control</div>
                                    <p>Blocks up to 99% of UV light, matte finish reduces glare. Offers maximum protection against fading and unwanted glare.</p>
                                </div>
                            )}
                            {s.prod && s.prod.IsFrame && s.prod.ProductID !== 84054 && s.prod.ProductID !== 70214 && s.prod.AllowGlassID2 > 0 && (
                                <div style={{marginTop: 8}}>
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/glass-all.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-all.png`}
                                            alt="Glass Info"
                                            style={{width: '100%'}}
                                        />
                                    </picture>
                                </div>
                            )}
                            {(!s.prod.AllowGlassID2 || s.prod.AllowGlassID2 < 1) && (
                                <div style={{marginTop: 8}}>
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/glass-46.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-46.jpg`}
                                            alt="Glass Info"
                                            style={{width: '100%'}}
                                        />
                                    </picture>
                                </div>
                            )}
                        </div>
                    </ModalSimple>
                    <ModalSimple
                        id="modal-plexi-info"
                        title="Plexiglass Information"
                    >
                        <div>
                            <div className="b">Why does this frame have plexiglass?</div>
                            <div>
                                Due to the large size of this frame, we use professional-grade plexiglass to reduce the possibility of breakage during shipping. Our high-quality plexi features the same level of document protection as our standard clear glass, and we also offer upgraded plexi options
                                for added protection.
                            </div>
                        </div>
                    </ModalSimple>

                    <div>
                        <div
                            style={{
                                padding: '0 12px',
                                position: 'relative',
                            }}
                        >
                            <div
                                role={this.canCollapse ? 'button' : undefined}
                                tabIndex={this.canCollapse ? 0 : undefined}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.currentTarget.click();
                                    }
                                }}
                                className="d-none d-xl-block toggle-bs"
                                data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                data-bs-target="#glass-inner"
                                aria-expanded={this.canCollapse ? false : undefined}
                                aria-controls={this.canCollapse ? 'glass-inner' : undefined}
                            >
                                <div className="cust-desktop-head">
                                    <span>Glass: </span>
                                    <span>
                                        {s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi ? 'Plexiglass ' : ''}
                                        {standardGlassTitle() || s.ui.name_glass}
                                    </span>
                                </div>
                            </div>

                            <div
                                role="button"
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.currentTarget.click();
                                    }
                                }}
                                className="d-block d-xl-none toggle-bs"
                                data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                data-bs-target="#glass-inner"
                                aria-expanded={this.canCollapse ? false : undefined}
                                aria-controls={this.canCollapse ? 'glass-inner' : undefined}
                            >
                                <div className="cust-flex-head">
                                    <div>
                                        <div
                                            className="header-std flexer cust-flex2"
                                            style={{paddingRight: '0.25rem'}}
                                        >
                                            Glass
                                        </div>
                                        <div className="cust-flex2">{standardGlassTitle() || s.ui.name_glass}</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: this.isMobile ? 6 : s.pcs.is_caf ? 10 : 5,
                                    left: this.isMobile ? 55 : 'auto',
                                    right: s.pcs.is_caf ? 40 : !this.isMobile ? 8 : 'auto',
                                }}
                            >
                                <InfoIcon
                                    id="modal-glass"
                                    ariaLabel="Open information about the glass upgrade options for this product"
                                    useMargin={true}
                                    styleBlack={true}
                                />
                            </div>
                        </div>
                        <div
                            id="glass-inner"
                            style={{
                                padding: '0 12px',
                            }}
                            className={this.canCollapse ? 'collapse' : ''}
                        >
                            <div
                                className="glass-prod"
                                role="listbox"
                                style={{paddingTop: 0}}
                                aria-label="Select frame glass"
                            >
                                {s.glass
                                    .filter(
                                        m =>
                                            ((s.prod.IsCAF && m.id !== 2) || m.id === 1 || (m.id === 2 && s.prod.AllowGlassID2 > 0) || (m.id === 3 && s.prod.AllowGlassID3 > 0) || (m.id === 4 && s.prod.AllowGlassID4 > 0)) &&
                                            (!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) || (AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && m.id !== 2 && m.id !== 3)),
                                    )
                                    .map(m => (
                                        <div
                                            key={m.id}
                                            title={standardGlassTitle(m.id) || m.title}
                                            aria-label={`Select ${standardGlassTitle(m.id) || m.title} glass`}
                                            className={`cust-entity${s.pcs.glass_id === m.id ? ' active' : ''}`}
                                            onClick={() => this.save(m.id)}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    this.save(m.id);
                                                }
                                            }}
                                            role="option"
                                            tabIndex={0}
                                        >
                                            <div className="title">
                                                {standardGlassTitle(m.id) || m.title} {m.price}
                                                {s.__fast_ship_orig && s.isRetail && m.id === 1 && (
                                                    <div className={`prod-fast-shipping fast-shipping-${s.PortalID}`}>
                                                        <i className={s.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}></i>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                            <div className="glass-info">
                                {(s.prod.AllowGlassID1 === 2 || s.pcs.use_plexi) && (
                                    <div className="mb-2">
                                        Why does this frame have plexiglass?{' '}
                                        <InfoIcon
                                            id="modal-plexi-info"
                                            ariaLabel="Why does this frame have plexiglass?"
                                            useMargin={true}
                                        />
                                    </div>
                                )}
                                <div>
                                    <button
                                        className="link link-btn"
                                        style={{fontSize: 16}}
                                        onClick={() => util.modal('modal-glass')}
                                        aria-label="Open information about glass options"
                                        type="button"
                                        aria-haspopup="dialog"
                                        aria-controls="modal-glass"
                                    >
                                        Learn more
                                    </button>{' '}
                                    about our document protection options.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
